<template>
  <div id="app" class="font-sans leading-tight">

    <!-- Map -->
    <StudentMap
      @mapMoved="mapMoved"
      @markerClicked="pointClicked"
      :markers="profiles"
    ></StudentMap>

    <transition name="slide-up">
      <div v-if="showMobileHelpers" class="absolute pin-b pin-l pin-r z-20 md:hidden">
        <div class="bg-brand p-2 text-white text-center font-bold shadow flex justify-between">
          <csf-button type="primary" class="inline-block pointer-events-auto" @click="addYourself">Add yourself</csf-button>
          <csf-button @click="showRandom">View random</csf-button>
        </div>
      </div>
    </transition>

    <div class="absolute pin-r pin-b pin-t pin-b pin-l p-8">
      <router-view :key="$route.fullPath" @showRandom="showRandom"></router-view>
    </div>

  </div>
</template>

<script>
import StudentMap from "../components/StudentMap";
import { mapGetters } from "vuex";
import { firebaseApp, firestore } from "../js/main.js";
import CsfButton from "../components/csf-button";

const initialState = "browse";

export default {
  name: "app",
  components: { StudentMap, CsfButton },
  data() {
    return {
      overlayOpen: false
    };
  },
  created() {
    this.bindRefs();
    // sign in anonymously
    firebaseApp
      .auth()
      .signInAnonymously()
      .then(result => {
        this.$store.commit("setAnonUID", { uid: result.uid });
      })
      .catch(function(error) {
        console.log(error);
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        // ...
      });
  },
  computed: {
    ...mapGetters([
      "currentState",
      "profiles",
      "profilesLoaded",
      "welcomeDismissed",
      "currentUserHasSavedEntry"
    ]),
    currentYear() {
      return this.$route.params.year;
    },
    inAddPointFlow() {
      return this.currentState != "browse";
    },
    showMobileHelpers() {
      return this.welcomeDismissed && this.$route.name != "add-point";
    }
  },
  watch: {
    currentYear() {
      // unset the profiles if the year changes
      this.$store.commit("setProfilesLoaded", false);
    },
    $route() {
      // get updated data even if reusing the component
      this.bindRefs();
    }
  },
  methods: {
    bindRefs() {
      if (this.profilesLoaded) return;
      else {
        const pinsRef = firestore
          .collection("/pins")
          .where("group", "==", this.currentYear);
        this.$store.dispatch("setPinsRef", pinsRef);
      }
    },
    mapMoved(e) {
      this.overlayOpen = false;
    },
    closeOverlay() {
      this.overlayOpen = false;
    },
    pointClicked(p) {
      this.closeOverlay();
      this.$router.push({ name: "profile", params: { id: p.id } });
    },
    addYourself() {
      this.$store.commit("centerMap", this.$store.state.initialMapCenter);
      this.$router.push({ name: "add-point" });
    },
    showRandom() {
      const profiles = this.$store.state.profiles;
      const randomIndex = Math.floor(Math.random() * profiles.length);
      const randomProfile = profiles[randomIndex];
      this.$router.push({
        name: "profile",
        params: { id: randomProfile.id }
      });
      this.$store.commit("centerMap", randomProfile.latlng);
    },
    checkIfUrlIsSignInLink() {
      // Confirm the link is a sign-in with email link.
      if (firebaseApp.auth().isSignInWithEmailLink(window.location.href)) {
        // Additional state parameters can also be passed via URL.
        // This can be used to continue the user's intended action before triggering
        // the sign-in operation.
        // Get the email if available. This should be available if the user completes
        // the flow on the same device where they started it.
        var email = window.localStorage.getItem("emailForSignIn");
        if (!email) {
          // User opened the link on a different device. To prevent session fixation
          // attacks, ask the user to provide the associated email again. For example:
          email = window.prompt("Please provide your email for confirmation");
        }
        // The client SDK will parse the code from the link for you.
        firebaseApp
          .auth()
          .signInWithEmailLink(email, window.location.href)
          .then(result => {
            console.log("Signed in!");
            console.log(result);
            console.log(result.user);
            this.authUser = result.user;
            // Clear email from storage.
            window.localStorage.removeItem("emailForSignIn");
            // You can access the new user via result.user
            // Additional user info profile not available via:
            // result.additionalUserInfo.profile == null
            // You can check if the user is new or existing:
            // result.additionalUserInfo.isNewUser
          })
          .catch(function(error) {
            console.log("Sign in failed...");
            console.log(error);
            // Some error occurred, you can inspect the code: error.code
            // Common errors could be invalid email and invalid or expired OTPs.
          });
      }
    }
  }
};
</script>

<style lang='scss'>
@import "../assets/sass/variables";

html,
body,
#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
  touch-action: none;
}
</style>



// WEBPACK FOOTER //
// App.vue?3970f1be